
    import I18n from 'i18nObj';
    
      import 'translations/zip_file_options_form';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('zip_file_options_form');
  